import { LocalStorageService } from '@aes/core';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

// key is used to access the app state in local storage
const LOCAL_STORAGE_APP_STATE_KEY = 'app-state';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {

  constructor(
    private _router: Router,
    private _localStorageService: LocalStorageService,
    private _oauthService: OAuthService) { }

  setState(routeUrl: string, value: any): void {
    const loggedUserEmail = this.getLoggedUserEmail();
    let storedState = this.getAppStateFromLocalStorage();
    storedState[loggedUserEmail][routeUrl] = value;

    this._localStorageService.setItem(LOCAL_STORAGE_APP_STATE_KEY, storedState);
  }

  getState(routeUrl: string): any {
    const loggedUserEmail = this.getLoggedUserEmail();
    let storedState = this.getAppStateFromLocalStorage();
    return storedState[loggedUserEmail][routeUrl] || {};
  }

  clearState(routeUrl: string): void {
    const loggedUserEmail = this.getLoggedUserEmail();
    let storedState = this.getAppStateFromLocalStorage();
    storedState[loggedUserEmail][routeUrl] = null;

    this._localStorageService.setItem(LOCAL_STORAGE_APP_STATE_KEY, storedState);
  }

  clear(): void {
    this._localStorageService.removeItem(LOCAL_STORAGE_APP_STATE_KEY);
  }

  setQueryParamsState(routeUrl: string, value: any): void {
    this._router.navigate([routeUrl], {
      queryParams: value,
    });
  }

  private getAppStateFromLocalStorage(): any {
    const loggedUserEmail = this.getLoggedUserEmail();
    let storedValue = this._localStorageService.getItem(LOCAL_STORAGE_APP_STATE_KEY) || {};

    if (!storedValue[loggedUserEmail]) {
      storedValue[loggedUserEmail] = {}
    }

    return storedValue;
  }

  private getLoggedUserEmail(): string {
    const claims = this._oauthService.getIdentityClaims();
    if (!claims) {
      return null;
    };

    return claims['email'];
  }
}
